import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: [],
  cartQuantity: 0,
  cartTotal: 0, // Add the cartTotal property
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const newItem = action.payload;

      const existingItem = state.cartItems.find(
        (item) => item.id === newItem.id
      );

      if (existingItem) {
        existingItem.quantity += newItem.quantity;
      } else {
        state.cartItems.push(newItem);
      }
      state.cartQuantity += newItem.quantity;
      state.cartTotal += newItem.price * newItem.quantity; // Calculate and update cartTotal
    },

    removeOneQuantityFromCart: (state, action) => {
      const productId = action.payload;
      const removedItem = state.cartItems.find((item) => item.id === productId);

      if (removedItem) {
        if (removedItem.quantity > 1) {
          removedItem.quantity -= 1;
          state.cartQuantity -= 1;
          state.cartTotal -= removedItem.price; // Adjust the cartTotal for a single item removal
        } else {
          // If there's only one item, remove the entire product
          state.cartItems = state.cartItems.filter(
            (item) => item.id !== productId
          );
          state.cartQuantity -= 1;
          state.cartTotal -= removedItem.price; // Adjust the cartTotal for a single item removal
        }
      }
    },

    removeItemFromCart: (state, action) => {
      const productId = action.payload;
      const removedItem = state.cartItems.find((item) => item.id === productId);

      if (removedItem) {
        state.cartQuantity -= removedItem.quantity;
        state.cartTotal -= removedItem.price * removedItem.quantity;

        // Remove the entire product from the cart
        state.cartItems = state.cartItems.filter(
          (item) => item.id !== productId
        );
      }
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.cartQuantity = 0;
      state.cartTotal = 0;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  removeOneQuantityFromCart,
  removeItemFromCart,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;
